/**
 * Creates an object composed of the picked `object` properties.
 */
function pick<T extends Record<string, any>, K extends keyof T>(
	object: T | null | undefined,
	...paths: (K | K[])[]
): Pick<T, K> {
	if (object == null) {
		return {} as Pick<T, K>;
	}

	const result = {} as Record<string, unknown>;
	const flatPaths = paths.flat() as K[];

	for (const path of flatPaths) {
		if (path in object) {
			result[path as string] = object[path];
		}
	}

	return result as Pick<T, K>;
}

export default pick;
